<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3VBjdg/tc-custom/9780253023377.jpg?1728353438823" alt="This image is the cover for the book Return of Nature, Studies in Continental Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of Nature, Studies in Continental Thought
      </h1>
      <p class="bookDescription body article font2">
        <b>A reflection on the urgent need for a new philosophical understanding of, and relationship with, nature.</b><br/><br/> John Sallis dismantles the traditional conception of nature in this book of imagination and the cosmos. In the thought of Emerson, Hegel, and Schelling, Sallis discerns the seeds of an understanding of nature that goes against the modern technological assault on natural things and opens a space for a revitalized approach to the world.<br/><br/> He identifies two fundamental reorientations that philosophical thought is called on to address today: the turn to the elemental in nature and the turn from nature to the cosmos at large. He traces the elusive course of the imagination, as if coming from nowhere, and describes the way in which it bears on the relation of humans to nature. Sallis’s account demonstrates that a renewal of our understanding of nature is one of the prime imperatives we demand from philosophy today.<br/><br/> “Inspiring . . . [for] anyone looking to open up their mind to the reflection on other ways to live more closely in tune with their own nature and to the nature that is around them.” —<i>Phenomenological Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Sallis
      </h2>
      
      <p class="authorDescription body article"><P>John Sallis is Frederick J. Adelmann Professor of Philosophy at Boston College. He is author of more than 20 books, including Light Traces (IUP, 2014) and Logic of Imagination (IUP, 2012).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13168727